import { Routes } from '@angular/router';
import { isAuthenticatedGuard } from './core/guards/is-authenticated.guard';
import { isNotAuthenticatedGuard } from './core/guards/is-not-authenticated.guard';
import { GetFiltersPresetListResolver } from './core/resolvers/get-filters-preset-list.resolver';
import { GetVariablesPresetListResolver } from './core/resolvers/get-variables-preset-list.resolver';
// import { GetQueriesPresetListResolver } from './core/resolvers/get-queries-preset-list.resolver';
import { GetYearListResolver } from './core/resolvers/get-year-list.resolver';
import { GetDownloadOptionsResolver } from './core/resolvers/get-download-options.resolver';
import { GetExtraOptionsResolver } from './core/resolvers/get-extra-options.resolver';
import { GetDbVersionResolver } from './core/resolvers/get-dbVersion.resolver';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(mod => mod.AUTH_ROUTES),
    canMatch: [isNotAuthenticatedGuard],
    canActivate: [isNotAuthenticatedGuard]
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then(mod => mod.HomeComponent),
    canMatch: [isAuthenticatedGuard],
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'download-one_multiple-firms',
    loadChildren: () => import('./download-one-multiple-firms/download-one-multiple-firms.routes').then(mod => mod.DOWNLOAD_ONE_MULTIPLE_FIRMS_ROUTES),
    canMatch: [isAuthenticatedGuard],
    canActivate: [isAuthenticatedGuard],
    resolve: {yearList: GetYearListResolver, downloadOptions: GetDownloadOptionsResolver, extraOptions: GetExtraOptionsResolver}
  },
  {
    path: 'account-details',
    loadComponent: () => import('./profile/profile.component').then(mod => mod.ProfileComponent),
    canMatch: [isAuthenticatedGuard],
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'help-center',
    loadComponent: () => import('./help-center/help-center.component').then(mod => mod.HelpCenterComponent),
    canMatch: [isAuthenticatedGuard],
    canActivate: [isAuthenticatedGuard],
    resolve: {dbVersion: GetDbVersionResolver}
  },
  {
    path: 'not-found',
    loadComponent: () => import('./not-found/not-found.component').then(mod => mod.NotFoundComponent),
  },
  {
    path: ':id',
    loadChildren: () => import('./consult-one-firm-details/consult-one-firm.routes').then(mod => mod.CONSULT_ONE_FIRM_ROUTES),
    canMatch: [isAuthenticatedGuard],
    canActivate: [isAuthenticatedGuard]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];
